'use strict';

export default function () {
    return {
        restrict: 'A',
        template: require('../view/welcome.html'),
        controllerAs: 'vm',
        controller: ['$scope',
        function(
        ) {

        }]
    };
}